import React, { useEffect, useState } from "react";
import s from "./PhotoGallery.less";
import PhotoModal from "~/pages/PhotoGallery/modals/PhotoGalleryModal";
import { useSetLocationData } from "~/hooks/locationData";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";
import { useTranslation } from "react-i18next";
import Button from "~/shared/ui/Fields/Button";
import Back from "~/components/Icons/arrow-prev2";
import { useHistory } from "react-router-dom";
import {
  DealerPhoto,
  useDealerPhotoGetterLazyQuery,
} from "~/schemas/generated/graphql";
import { useURLParamsGetter } from "~/hooks/useURLParamsSetter";
import { get } from "lodash";
import Pagination from "~/components/Pagination";
import Preloader from "~/components/Preloader";
import clsx from "clsx";
import PhotoGalleryCard from "~/components/PhotoGalleryCard";

const PhotoGallery: React.FC = () => {
  const [total, setTotal] = useState(0);
  const [photos, setPhotos] = useState([]);
  const [selectedImage, setSelectedImage] = useState<DealerPhoto | null>(null);
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const history = useHistory();
  const currentDealerId = useCurrentDealerId();
  const { page, count, openModal } = useURLParamsGetter<{
    page: number;
    count: number;
    openModal: string;
  }>();
  const goBack = () => {
    history.replace("/");
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
    setData("openModal", "");
  };

  const handleImageClick = (image: DealerPhoto) => {
    setSelectedImage(image);
    setData("openModal", "PhotoGallery");
  };

  const getDealerPhotosHandler = () => {
    getDealerPhotos({
      variables: {
        dealerId: currentDealerId,
        page: Number(page),
        count: Number(count),
      },
    });
  };
  useEffect(() => {
    getDealerPhotosHandler();
  }, [page, count]);

  const [getDealerPhotos, getDealerPhotosState] = useDealerPhotoGetterLazyQuery(
    {
      fetchPolicy: "no-cache",
    }
  );

  useEffect(() => {
    if (getDealerPhotosState.loading) getDealerPhotosState.data = undefined;
    if (getDealerPhotosState.data) {
      const requestData = get(
        getDealerPhotosState.data,
        "DealerPhotoGetter.getDealerPhotos"
      );
      if (requestData) {
        setTotal(Number(requestData.total) || 0);
        setPhotos(Array.isArray(requestData.items) ? requestData.items : []);
      }
    }
  }, [getDealerPhotosState.loading]);

  selectedImage && console.log(selectedImage, "originalUrl");
  return (
    <div className={s.wrapper}>
      <div className={s.galleryShape}>
        <div className={s.title}>{t("photoGallery.title")}</div>
        <Button txtBtn={"Назад"} onClick={goBack} small>
          <Back />
        </Button>
      </div>
      <Pagination total={total} isElements={true}>
        <div
          className={clsx(s.parent, {
            [s.gridLayout]: !getDealerPhotosState.loading,
            [s.flexLayout]: getDealerPhotosState.loading,
          })}
        >
          {selectedImage && (
            <PhotoModal
              isOpen={openModal === "PhotoGallery"}
              imageLink={selectedImage.originalUrl}
              description={selectedImage.PhotoGallerySection.description}
              title={selectedImage.PhotoGallerySection.title}
              onClose={handleCloseModal}
              withoutMargin
            />
          )}

          {getDealerPhotosState.loading ? (
            <div className={s.preloaderWrapper}>
              <Preloader />
            </div>
          ) : (
            photos?.map((photo) => (
              <PhotoGalleryCard
                onClick={() => handleImageClick(photo)}
                key={photo.id}
                src={photo.previewUrl}
                className={s.photo}
                alt={`Photo ${photo.id}`}
              />
            ))
          )}
        </div>
      </Pagination>
    </div>
  );
};

export default PhotoGallery;
